import { getDate1, getTime1} from "../common/util/appUtils";
import { useEffect, useState } from "react";
import "../common/header/header.css"; 
import "../common/style.css";
import { faBell, faCircle, faComment, faUser} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import 'moment-timezone'; 
import "bootstrap/dist/js/bootstrap"; 
import "bootstrap/dist/css/bootstrap.min.css"; 
import "bootstrap/js/src/dropdown"; 
import "../App.css";  
import _ from "lodash"; 
import NotificationAPI from "../common/util/NotificationAPI"; 
import remIcoCutom from "../assets/images/reminder_icon_custom.svg";   
import DOMPurify from "dompurify"; 

export default function DisplayNotification({ message ,handleNotificationHyperlink, getNotification}) {
    const [messageData, setMessageData] = useState({});
    const [contextMenu, setContextMenu] = useState({
      visible: false,
      x: 0,
      y: 0,
      event: null
    });

    useEffect(() => {
      const handleClickOutside = () => {
        setContextMenu((prev) => ({ ...prev, visible: false }));
      };
      if (contextMenu.visible) {
        document.addEventListener("click", handleClickOutside);
      }
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [contextMenu.visible]);

    const updateNotification = (data) => {
        NotificationAPI.UpdateNotification(data)
          .then((result) => {
            getNotification();
          })
          .catch((err) => {
            console.error(err);
          });
      }; 
    const displayNotification = (message) => { 
        if (
          message.Type == "Mention" ||
          message.Type == "Task" ||
          message.Type == "Assignee" ||
          message.Type == "Message" ||
          message.Type == "Attachment" ||
          message.Type == "Reminder" ||
          message.Type == "Notes" ||
          message.Type == "Bug"
        ) { 
          return (
            <li
              style={{ padding: "15px 0px" }}
              className={message.IsRead ? "row" : "unreadNotification row pb-2"}
                >
              <div className="notificationIcon col-1">
                <span
                // className={message.IsRead || (message.ROWID == messageData.ROWID) ? "checkBox-bg" : ""}
                >
                  {message.IsRead || message.ROWID == messageData.ROWID ? (
                    message.Type == "Reminder" ? (
                      <img
                        className="reminder-icon-cust"
                        style={{ backgroundColor: "#5b6c97", borderRadius: "50%" }}
                        src={remIcoCutom}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={
                          message.Type == "Reminder"
                            ? faBell
                            : message.Type == "Assignee"
                            ? faUser
                            : faComment
                        }
                        onMouseLeave={() => {
                          // setMessageData({});
                        }}
                        onMouseEnter={() => {
                          // setMessageData(message);
                        }}
                      />
                    )
                  ) :  
                  message.Type == "Reminder" ? (
                    <img
                      className="reminder-icon-cust"
                      style={{ backgroundColor: "#5b6c97", borderRadius: "50%" }}
                      src={remIcoCutom}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={
                        message.Type == "Reminder"
                          ? faBell
                          : message.Type == "Assignee"
                          ? faUser
                          : faComment
                      }
                    />
                  )}
                </span>
              </div>
              <div className="col">
                <div className="row">
                  <div
                    className="col-4 d-flex justify-content-end"
                    style={{ flexDirection: "column" }}
                  >
                    {message.IsRead ? (
                      <h6 className="notifType">{message.Type}</h6>
                    ) : (
                      <strong>
                        <h6 className="notifType">{message.Type}</h6>
                      </strong>
                    )}
                  </div>
                  <div className="col-8 d-flex  justify-content-end">
                    <div>
                      {message.IsRead ? (
                        <></>
                      ) : (
                        <FontAwesomeIcon
                          className="notify-isRead custom-dot-icon"
                          icon={faCircle}
                        />
                      )}
                    </div>
                    {message.IsRead ? (
                      <>
                        <span>{getDate1(message.CREATEDTIME)}</span>&nbsp;at&nbsp;
                        <span>{getTime1(message.CREATEDTIME)}</span>
                      </>
                    ) : (
                      <strong>
                        <span>{getDate1(message.CREATEDTIME)}</span> at{" "}
                        <span>{getTime1(message.CREATEDTIME)}</span>
                      </strong>
                    )}
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingLeft: "15px" }} 
              onContextMenu={e=>{
                e.preventDefault();
                e.stopPropagation();
                e.persist();
                setContextMenu({visible: true, x: e.clientX, y: e.clientY,  target: e.target,
    currentTarget: e.currentTarget})}}
              onClick={(e) => handleNotificationHyperlink(e)}>
                <div className="col-1"></div>
    
                <div className="notificationText pl-4 col d-flex pr-0">
                   
                  {message.IsRead ? (
                    <div
                      className="notifications-hyperlinks my-1"
                      onClick={(e) => handleNotificationHyperlink(e)}
                      onContextMenu={e=>{
                        e.preventDefault();
                        e.stopPropagation();
                        e.persist();
                        setContextMenu({visible: true, x: e.clientX, y: e.clientY,  target: e.target,
    currentTarget: e.currentTarget})}}
                      // onMouseDown={(e) => handleNotificationHyperlink(e)}
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.Text) }}
                    ></div>
                  ) : (
                    <strong>
                      <div
                        className="notifications-hyperlinks my-1"
                        onClick={(e) => handleNotificationHyperlink(e)}
                        onContextMenu={e=>{
                          e.preventDefault();
                          e.stopPropagation();
                          e.persist();
                          setContextMenu({visible: true, x: e.clientX, y: e.clientY,  target: e.target,
    currentTarget: e.currentTarget})}}
                        // onMouseDown={(e) => handleNotificationHyperlink(e)}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.Text) }}
                      ></div>
                    </strong>
                  )}
                </div>
              </div>
              <div className="notificationTime">
                <div className="notification-unread-button">
                    
                  {message.IsRead ? (
                    <span
                      onClick={() => {
                        let data = { ...message };
                        data.IsRead = false;
                        updateNotification(data);
                      }}
                    >
                      Mark as unread
                    </span>
                  ) : (
                    <span
                      onClick={() => {
                        let data = { ...message };
                        data.IsRead = true;
                        updateNotification(data);
                      }}
                    >
                      Mark as read
                    </span>
                  )}
                </div>
                <div className="notification-unread-button ml-2">
    
                  {message.IsArchive ? (
                    <span
                      onClick={() => {
                        let data = { ...message };
                        data.IsArchive = false;
                        updateNotification(data);
                      }}
                    >
                     Active
                    </span>
                  ) : (
                    <span
                      onClick={() => {
                        let data = { ...message };
                        data.IsArchive = true;
                        updateNotification(data);
                      }}
                    >
                      Archive
                    </span>
                  )}
                </div>
              </div>
            </li>
          );
        } 
      }; 
  return (
    <>
    {contextMenu.visible && (
      <div
        className="custom-context-menu"
        onClick={e=>e.stopPropagation()}
        style={{
          top: contextMenu.y,
          left: contextMenu.x,
        }}
      >
        <button
            style={{ border: '1px solid lightgray' }}
            onClick={(e) => {
              e.stopPropagation();
              if (contextMenu.currentTarget) {
                handleNotificationHyperlink({currentTarget: contextMenu.currentTarget,target: contextMenu.target},true);
              }
              setContextMenu((prev) => ({ ...prev, visible: false }));
            }}
          >
            Open in new tab
          </button>
      </div>
    )}
  <div>{displayNotification(message)}</div>
  </>
  )
}
